/**
 * Day↔night handoff — stage chrome fade windows (see docs/sky-clock.md).
 */

export function clamp01(v) {
  if (v <= 0) return 0;
  if (v >= 1) return 1;
  return v;
}

/**
 * Stage-only UI alpha during celestial transition.
 * 0–fadeMs: 1→0, mid: 0, last fadeMs: 0→1.
 * @param {number} elapsedMs
 * @param {number} totalMs
 * @param {number} [fadeMs]
 */
export function computeStageElementAlpha(elapsedMs, totalMs, fadeMs) {
  var total = Math.max(1, Number(totalMs) || 3000);
  var fade = Math.max(1, Number(fadeMs) || 300);
  var e = Math.max(0, Number(elapsedMs) || 0);
  if (e <= fade) return clamp01(1 - e / fade);
  if (e >= total - fade) return clamp01((e - (total - fade)) / fade);
  return 0;
}
